






































































































































































import UUIFComponent from '@/shared/uuifComponent';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { InfoState } from '@/core';
import { SwCheckbox } from '@libs-uuif/shared/sw-checkbox';
import { confirmService, ConfirmOptions, ConfirmButton } from '@sonicwall/unified-ui-framework/src/shared/confirm-service';

const cssPrefix = 'delete-products';

@Component({
  components: {
    ...UUIFComponent,
    SwCheckbox,
  },
})
export default class DeleteProduct extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ default: [] })
  selectedProducts: any[];
  @Prop()
  openDeleteModal: boolean;
  @Prop({ default: 'products-tab' })
  setWidthAndHeight: string;

  get hasCloudSecureEdge(): boolean {
    return this.selectedProducts.some((p: any) => p.productName === 'Sonicwall Cloud Secure Edge');
  }

  get isDeleteDisabled(): boolean {
    if (!this.hasCloudSecureEdge) { return false; }
    return this.deleteConfirmText.trim().toUpperCase() !== 'DELETE-PRODUCT';
  }

  reasonSelected: string = 'Decommissioned';
  deleteConfirmText: string = '';
  otherReason: string = '';
  confirmTransferFlag: boolean = false;
  transferCheck: boolean = false;
  showOnpremNote: boolean = false;
  isShowCaptureClientNote: boolean = false;
  deleteReasonOptions: any[] = [
    { label: this.$t('products.deleteProduct.decommissioned'), id: 'Decommissioned', value: 'Decommissioned' },
    { label: this.$t('products.deleteProduct.returned'), id: 'Returned', value: 'Returned' },
    { label: this.$t('products.deleteProduct.upgrdToSonicwall'), id: 'Upgraded', value: 'Upgraded' },
    { label: this.$t('products.deleteProduct.nonSonicwallSoln'), id: 'Replaced', value: 'Replaced' },
    { label: this.$t('products.deleteProduct.other'), id: 'Other', value: 'Other' },
  ];

  mounted() {
    if (this.selectedProducts) {
      const onPremSerials = this.selectedProducts.filter((product: any) => {
        return product.pID === '7636';
      });
      const onCaptureClientSerials = this.selectedProducts.filter((product: any) => {
        return product.pID === '401';
      });
      if (onPremSerials && onPremSerials.length > 0) {
        this.showOnpremNote = true;
      } else {
        this.showOnpremNote = false;
      }
      if (onCaptureClientSerials && onCaptureClientSerials.length > 0) {
        this.isShowCaptureClientNote = true;
      } else {
        this.isShowCaptureClientNote = false;
      }
    }
  }
  deleteSerial() {
    const deleteReason = this.deleteReasonOptions.find(item => item.value === this.reasonSelected).label;
    const productsList: any[] = [];
    this.selectedProducts.forEach((prod, index) => {
      if (this.confirmTransferFlag) {
        productsList.push({
          // tslint:disable-next-line:max-line-length
          index, serialNumber: prod.serNo, comments: this.reasonSelected === 'Other' ? this.otherReason : deleteReason, s1DeleteAction: '', isdeletebackupconfirm: this.transferCheck ? 'YES' : 'NO',
        });
      } else {
        productsList.push({
          // tslint:disable-next-line:max-line-length
          index, serialNumber: prod.serNo, comments: this.reasonSelected === 'Other' ? this.otherReason : deleteReason, s1DeleteAction: '',
        });
      }
    });
    //  this is temporary fix for the single  capture client product to be deleted. later after the fix this need to be modified.
    // tslint:disable-next-line:max-line-length
    if (productsList.length === 1 && this.selectedProducts.length === 1 &&  this.selectedProducts[0].pID === '401' && this.selectedProducts[0].isDeleteAllowed === 'YES') {
      productsList[0].s1DeleteAction = 'DELETE';
    }
    const payload = { overrideDeleteValidate: 'NO' ,
      request: { prodsDeleteList: productsList },
    };
    this.$store.commit('startLoading');
    this.$store.dispatch('MswProductsStoreModule/deleteProduct', payload)
    .then((res) => {
      setTimeout(() => {
        this.$store.commit('stopLoading');
      }, 3000); // tslint:disable-line 
      if ((res.arrInput && res.arrInput[0] && res.arrInput[0].ErrorCode && res.arrInput[0].ErrorCode === 'CSCENABLED') || res.msgCode === 'CSCENABLED') {
        const errMessage = res.msgCode === 'CSCENABLED' ? res.msgDesc : res.arrInput[0].ErrorMessage;
        this.showConfirmDialog(errMessage)
        .then((key: any) => {
          if (key === 'save') {
            payload.overrideDeleteValidate = 'YES';
            this.$store.commit('startLoading');
            this.$store.dispatch('MswProductsStoreModule/deleteProduct', payload)
            .then((res) => {
              setTimeout(() => {
                this.$store.commit('stopLoading');
              }, 3000); // tslint:disable-line 
              this.handleResponse(res);
            });
          }
        });
      } else {
        this.handleResponse(res);
      }
    });
  }

  handleResponse(res: any) {
    if (res.msgCode === 'MSWAPP:PRODSDELETESUCCESS') {
      const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
      this.$emit('delete-success');
      this.close();
    } else if (res.msgCode === 'MSWAPP:PRODSDELETECONFIRMBACKUP') {
      this.confirmTransferFlag = true;
      const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
    } else {
      const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
      this.$store.commit('enqueueMessage', message);
    }
  }

  showConfirmDialog(message: string) {
    const buttonsTransferConfirm: ConfirmButton[] = [
      { key: 'cancel', name: 'Cancel', isDefault: true },
      { key: 'save', name: 'Confirm' },
    ];
    const optionsTransferConfirm: ConfirmOptions = {
      message,
      status: 'high',
      title: 'Warning',
      buttons: buttonsTransferConfirm,
    };
    return confirmService.confirm(optionsTransferConfirm);
  }

  close() {
    this.deleteConfirmText = '';
    this.$emit('request-close');
  }
}
